/** Salesforce objects this lookup can search — values must match the host LWC's routing (`complexContractsEmbed.js`'s `LOOKUP_OBJECT_API_NAMES`). */
export enum LookupObjectApiName {
  Account = 'Account',
  Contact = 'Contact',
  PaymentTerm = 'Payment_Terms__c',
  ShipTo = 'Address__c',
}

export enum IconCategory {
  Action = 'action',
  Custom = 'custom',
  Doctype = 'doctype',
  Standard = 'standard',
  Utility = 'utility',
}
